var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.432 12.5H6.75a1.434 1.434 0 0 0 1.432-1.432V4.113A1.434 1.434 0 0 0 6.75 2.682H1.432A1.434 1.434 0 0 0 0 4.113v6.955A1.434 1.434 0 0 0 1.432 12.5ZM1.09 4.113a.34.34 0 0 1 .34-.34H6.75a.34.34 0 0 1 .34.34v6.955a.341.341 0 0 1-.34.34H1.432a.341.341 0 0 1-.341-.34V4.113Z",
    fill: "#979BA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.565.5H5.253a1.434 1.434 0 0 0-1.32.878.546.546 0 1 0 1.004.426.344.344 0 0 1 .316-.213h5.312a.344.344 0 0 1 .344.344v6.949a.344.344 0 0 1-.344.343H9.273a.545.545 0 1 0 0 1.091h1.292A1.437 1.437 0 0 0 12 8.884v-6.95A1.436 1.436 0 0 0 10.565.5Z",
    fill: "#979BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.869a59c38d088c34c71225f93a29a19a.svg";
export { ForwardRef as ReactComponent };